import { render, staticRenderFns } from "./TmStandard.vue?vue&type=template&id=e32dea1c"
import script from "./TmStandard.vue?vue&type=script&lang=ts"
export * from "./TmStandard.vue?vue&type=script&lang=ts"
import style0 from "./TmStandard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Headline: require('/app/components/base/Headline/Headline.vue').default,ButtonComponent: require('/app/components/base/ButtonComponent/ButtonComponent.vue').default,Icon: require('/app/components/base/Icon/Icon.vue').default})
